import request from "@/utils/request";

export default function page(current=1,size=10,params) {
    return request({
        url: `/merchant/agency/page/`+current+`/`+size,
        method: 'get',
        params
    })
}
